import { useContext, useEffect } from 'react'
import { NavigationNode } from '../../Services/Navigation'
import API from '../../Services/API'
import './LastPageView.css'
import { ConfiguratorContext } from '../../Contexts/Configuration'
import { CustomerType } from '../../Enums/CustomerType'
import CustomerRequest from '../../Requests/CustomerRequest'

const LastPageView = () => {
	let context = useContext(ConfiguratorContext)

	useEffect(() => {
		(async () => {
			let customer: CustomerRequest = {
				business_name: context.businessName,
				first_name: context.name!,
				last_name: context.surname!,
				email: context.email!,
				pec: context.pec,
				status: "prospect",
				phone: context.phone,
				address: context.address,
				billing_address: context.billingAddress,
				cap: context.cap,
				billing_cap: context.billingCap,
				province: context.province,
				billing_province: context.billingProvince,
				municipality: context.common,
				billing_municipality: context.billingMunicipality,
				city: context.common,
				birth_place: context.birthMunicipality === undefined ? undefined : context.birthMunicipality + ' ' + context.birthProvince,
				fiscal_code: context.fiscalCode,
				vat_number: context.vatNumber,
				sdi: context.sdi,
				gender: context.gender ? 'M' : 'F',
				birthday: context.birthDate,
				civic_number: parseInt(context.civicNumber!),
				billing_civic_number: parseInt(context.billingCivicNumber!),
				type: context.isHomeUse ? CustomerType.Private : CustomerType.Professional,
				iban: context.iban,
				bank: context.bank,
				bank_place: context.place,
				document_type: context.documentType,
				document_number: context.documentNumber,
				document_expiration: context.documentExpiration,
			}
			await API.updateCustomerAsync(context.customerId!, customer)

			await API.sendContractEmailAsync(context.contractId!, (context.paymentType?.name === 'RID' ? 1 : 0), (context.voipSelected ? 1 : 0))
		})()
		return () => { }
	}, [])

	return (
		<div className='last-page-container'>
			<div className='last-page-title'>DigitalReti ti ringrazia per la tua scelta, sarai presto contattato dal nostro staff per darti il benvenuto!</div>
			<div className='last-page-menu'>
				<div>Riceverai via mail la nostra proposta.</div>
				<div className='last-page-submenu'>
					<a href={`${process.env.REACT_APP_HOST}/api/contracts/${context.contractId}/download/${context.paymentType?.name === 'RID' ? 1 : 0}/${context.voipSelected ? 1 : 0}`}>
						<button className='last-page-button'>Scarica tutta la documentazione del contratto</button>
					</a>
				</div>
			</div>
		</div>
	)
}

const LastPageNode: NavigationNode = {
	previous: () => undefined,
	next: () => undefined,
	content: () => <LastPageView />,
	percentage: undefined
}

export default LastPageNode
